import tw, { TwStyle } from 'twin.macro'

export function flowEditorCheckboxBoxCss(checked: boolean, disabled: boolean): TwStyle[] {
  const base = tw`box-border flex h-[18px] w-[18px] flex-shrink-0 items-center justify-center rounded border-2 border-solid transition-all duration-[120ms]`

  if (disabled && checked) {
    return [base, tw`cursor-not-allowed border-shades-300 bg-shades-300 opacity-[0.85]`]
  }

  if (disabled) {
    return [base, tw`cursor-not-allowed border-shades-300 bg-shades-50 opacity-[0.85]`]
  }

  if (checked) {
    return [base, tw`cursor-pointer border-primary-500 bg-primary-500`]
  }

  return [base, tw`cursor-pointer border-shades-300 bg-shades-0`]
}

export function flowEditorCheckboxMarkCss(disabled: boolean): TwStyle {
  return disabled ? tw`stroke-shades-0` : tw`stroke-white`
}
